import type { AppConfig } from "@config";

const isObject = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null && !Array.isArray(value);

const isAppConfig = (value: unknown): value is AppConfig =>
    isObject(value) &&
    !Object.prototype.hasOwnProperty.call(value, "__REPLACE_WITH_ENVIRONMENT_CONFIG__") &&
    Object.values(value).every((setting) => typeof setting === "string");

export async function loadRuntimeConfig(url: string): Promise<void> {
    const response = await fetch(url, { cache: "no-store" });

    if (!response.ok) {
        throw new Error(`Unable to load runtime configuration from ${url} (HTTP ${response.status}).`);
    }

    const config: unknown = await response.json();

    if (!isAppConfig(config)) {
        throw new Error(`Runtime configuration at ${url} must be a JSON object containing string values.`);
    }

    window.__CRUX_CONFIG__ = config;
}
